import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'

@Component({})
export default class BasePage extends Vue {
  public isMounted: boolean = false;

  mounted() {
    this.isMounted = true;
  }

  renderByStore(params) {
    const columnValue = params.row[params.column.property]
    const findSource = this[params.column.property].find(value => {
      return value.value === columnValue
    })

    const value = findSource ? findSource.label : columnValue
    if (value) {
      return value;
    }
    else {
      return columnValue;
    }
  }



  public hasSelection(table) {
    if (this.isMounted && this.$refs[table]) {
      return (this.$refs[table] as any).getSelections().length > 0;
    } else {
      return false;
    }
  }

  /**
   * 行数据加载到Form上
   * @param formModel form对应的实体模型
   * @param data 行数据
   * @param url 如果设置了url 会根据url远程获取数据(防止脏数据)
   */
  public loadForm(formModel: any, data: any, url?: string) {
    // el对form组件实现了懒加载,同时form重置时,重置的值以form组件挂载时候绑定的v-model为主
    // 如果在form挂载之前先执行model的赋值 会导致所有的重置操作都会更新成第一次选中的行数据
    // 这里使用setTimeout滞后100毫秒加载数据
    setTimeout(() => {
      for (const key in formModel) {
        if (formModel.hasOwnProperty(key)) {
          if (isNaN(data[key]) && moment(data[key], moment.ISO_8601).isValid()) {
            formModel[key] = moment(data[key]).toDate()
          } else {
            formModel[key] = data[key]
          }
        }
      }
    }, 100);
  }

  /**
   * 验证表单输入是否合法
   * @param fromRef 表单ref
   * @param action 执行回调
   */
  public async isFormValid(fromRef: string, action: (valid) => void) {
    (this.$refs[fromRef] as any).validate((valid) => {
      action(valid);
    });
  }

  /**
  * 重置表单内容
  * @param fromRef 表单ref
  */
  public resetForm(fromRef: string) {
    if (this.$refs[fromRef]) {
      (this.$refs[fromRef] as any).resetFields();
    }

  }

  public buildColumn(code: string, columns: any[]) {
    columns.splice(0);
    this.$http.get("/Home/GetColumnConfig", { params: { code: code } }).then(res => {
      this.createColumn(res.data.data, columns)
    });
  }

  private createColumn(data: Array<any>, columns: any[]) {
    let currGroupHeader = '';
    let colHeader = null;
    data.forEach(item => {
      if (!item.cGroupHeader) {
        if (colHeader) {
          columns.push(colHeader);
        }
        colHeader = null;
        columns.push(this.addAttributes(item));
      }
      else {
        if (item.cGroupHeader !== currGroupHeader) {
          if (colHeader) {
            columns.push(colHeader);
          }
          currGroupHeader = item.cGroupHeader;
          colHeader = this.addAttributes(item);
        }
        item.cGroupHeader = '';
        colHeader.columns.push(this.addAttributes(item));
      }
    })
    if (colHeader) {
      columns.push(colHeader);
    }
  }

  private addAttributes(columnConfig: any) {
    if (columnConfig.cDataType === "other") {
      return {
        label: columnConfig.cTitle,
        width: columnConfig.nWidth,
        fixed: columnConfig.cFixed,
        align: columnConfig.cAlign,
        render: this[columnConfig.cColumnRender],
        renderHeader: this[columnConfig.cHeaderRender]
      }
    }

    if (!columnConfig.cGroupHeader) {
      let options;
      if (columnConfig.iOptionType && columnConfig.cOptionSource) {
        switch (columnConfig.iOptionType) {
          case 1:
            options = this.$utils.Evil(columnConfig.cOptionSource);
            break;
          case 2:
            options = this[columnConfig.cOptionSource];
            break;
          case 3:
            options = this[columnConfig.cOptionSource]();
            break;
        }
      }
      return {
        prop: columnConfig.cField,
        label: columnConfig.cTitle,
        width: columnConfig.nWidth,
        align: columnConfig.cAlign,
        fixed: columnConfig.cFixed,
        attrs: {
          type: columnConfig.cDataType,
          precision: columnConfig.nPrecision,
          editable: columnConfig.iEdit === 1,
          sortable: columnConfig.iSort === 1,
          summary: columnConfig.iSum === 1,
          spanable: columnConfig.iSpan === 1,
          options,
          label: 'label',
          value: 'value',
          change: (oldVal, newVal, row) => {
            if (columnConfig.cChangeFn) {
              this[columnConfig.cChangeFn](oldVal, newVal, row);
            }
          }
        },
        formatter: columnConfig.cFormatter ? (row, col, value, index) => {
          if (columnConfig.cFormatter) {
            return this[columnConfig.cFormatter](row, col, value, index)
          }
          else return value;
        } : null,
        render: this[columnConfig.cColumnRender],
        renderHeader: this[columnConfig.cHeaderRender]
      }
    }
    else {
      return {
        label: columnConfig.cGroupHeader,
        align: "center",
        attrs: {},
        columns: []
      }
    }
  }

  public applayButtonRole(code: string, btnModel: object) {

    this.$http.get('/Home/LoadButtonRole', { params: { code: code } }).then(res => {
      const data = res.data.data
      data.forEach(item => {
        btnModel[item.cButtonID] = true
      })
    }).catch(err => {
      this.$message.error(err)
    })
  }

  /**
   * 转换为带时间日期格式
   * @param h element创建器
   * @param params 列信息参数
   */
  public formatDateTime(row, col, val, index) {
    return this.DateFormat('yyyy-MM-dd HH:mm:ss', new Date(val))
  }

  public formatDate(row, col, val, index) {
    return this.DateFormat('yyyy-MM-dd', new Date(val))
  }
  public formatSelect(row, col, val, index) {
    const findSource = this[col.property].find(value => {
      return value.value === val
    })

    const value = findSource ? findSource.label : val
    if (value) {
      return value;
    } else {
      return ''
    }
  }

  public DateFormat(formatter: string, date: Date): string {
    const o = {
      'M+': date.getMonth() + 1,                 // 月份
      'd+': date.getDate(),                    // 日
      'H+': date.getHours(),                   // 小时
      'm+': date.getMinutes(),                 // 分
      's+': date.getSeconds(),                 // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds()             // 毫秒
    }
    if (/(y+)/.test(formatter)) {
      formatter = formatter.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(formatter)) {
        formatter = formatter.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return formatter
  }

}

